import { render, staticRenderFns } from "./TicketingTaskEntry.vue?vue&type=template&id=4cf64c5e&scoped=true"
import script from "./TicketingTaskEntry.vue?vue&type=script&lang=js"
export * from "./TicketingTaskEntry.vue?vue&type=script&lang=js"
import style0 from "./TicketingTaskEntry.vue?vue&type=style&index=0&id=4cf64c5e&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf64c5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardText,VCardTitle,VFlex,VIcon,VLayout,VListItem,VListItemAction,VListItemTitle})
